import React from 'react';
import { WithIcon } from './WithIcon';

export const IconShareIos = WithIcon(
  'Share iOS',
  '0 0 25 25',
  <path
    id="prefix__a"
    d="M2.178 13.16v9.069c0 .696.564 1.26 1.26 1.26H19.56c.695 0 1.26-.564 1.26-1.26V13.16h1.51v9.069c0 1.53-1.24 2.771-2.77 2.771H3.438c-1.53 0-2.771-1.24-2.771-2.771V13.16h1.511zM11.498 0l6.58 6.58L17.01 7.65l-4.756-4.757v16.314h-1.511V2.893L5.987 7.649 4.92 6.58 11.499 0z"
  />
);
